<template lang="pug">
    div(class="subtitle-text primary--text") Status Penduduk                                        
        v-radio-group(dense v-model="type" @change="onSelect" :readonly="readonly")
            v-radio(label="Resident" value="1" color="primary" )
            v-radio(label="Non Resident" value="2" color="primary")
</template>
<script>
export default {
    name: "FRadioResidentExt",
    props: ["value","readonly"],
    data() {
        return {
            type: null
        };
    },
    mounted() {
        this.doInitModel(this.value);
    },
    watch: {
        value(val) {
            this.doInitModel(val);
        }
    },
    methods: {
      doInitModel(values) {
          this.type = values ? "" + values : "1";
          this.onSelect();
      },
      onSelect() {
          this.$emit("input", this.type);
          this.$emit("select", this.type);
      }
    }
};
</script>